import { tourStep } from './tourRegistry';

export const bandaPermisosSteps = [
  tourStep(
    'permisos-header',
    'Permisos de gestión',
    'Solo el titular ve esta pantalla. Crea usuarios (email y contraseña) para directores o directiva.',
  ),
  tourStep(
    'permisos-add',
    'Añadir usuario',
    'El delegado entra con su cuenta y solo ve los módulos que marques: archivo, músicos, ensayos, Tu Web, etc.',
  ),
  tourStep(
    'permisos-tabla',
    'Usuarios delegados',
    'Lista de colaboradores. Edita para cambiar módulos o desactivar el acceso.',
    'top',
  ),
];
